// This file is auto-generated by ./bin/rails view_component:stimulus_manifest:update
// Run that command whenever you add a new controller in ViewComponent

import { application } from "./application"

import ChatNewMessage__AutofitController from "../../../apps/chat_app/app/components/chat_new_message/autofit_controller"
application.register("chat-new-message--autofit", ChatNewMessage__AutofitController)

import ChatNewMessage__SubmitController from "../../../apps/chat_app/app/components/chat_new_message/submit_controller"
application.register("chat-new-message--submit", ChatNewMessage__SubmitController)

import ChatWindow__ScrollController from "../../../apps/chat_app/app/components/chat_window/scroll_controller"
application.register("chat-window--scroll", ChatWindow__ScrollController)

import TopicRow__ComponentController from "../../../apps/topic_app/app/components/topic_row/component_controller"
application.register("topic-row--component", TopicRow__ComponentController)

import CardUser__ReadMoreController from "../../../apps/tri_app/app/components/card_user/read_more_controller"
application.register("card-user--read-more", CardUser__ReadMoreController)
